/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Scope_Shop_AuthInputs */

const vi_api_keys_scope_shop_auth = /** @type {(inputs: Api_Keys_Scope_Shop_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập web (shop_auth)`)
};

/**

* @param {Api_Keys_Scope_Shop_AuthInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_scope_shop_auth = /** @type {((inputs?: Api_Keys_Scope_Shop_AuthInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Scope_Shop_AuthInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_scope_shop_auth(inputs)
});